import { apiClient } from '@/api/client'
import type { ApiResponseWrapper } from '@/types/api.types'

export const HR_STRUCTURE_KINDS = [
  'department', 'team', 'position', 'job_title', 'grade', 'employment_type',
] as const
export type HrStructureKind = (typeof HR_STRUCTURE_KINDS)[number]

export interface HrStructureRecord {
  _id: string
  companyId: string
  kind: HrStructureKind
  name: string
  code?: string
  parentId?: string
  headcount?: number
  vacancyState?: 'open' | 'filled' | 'paused'
  active: boolean
}

export interface HrStructurePayload {
  kind: HrStructureKind
  name: string
  code?: string
  parentId?: string
  headcount?: number
  vacancyState?: 'open' | 'filled' | 'paused'
}

function path(companyId: string): string {
  return `/companies/${companyId}/hr/structure`
}

export async function listHrStructure(companyId: string): Promise<HrStructureRecord[]> {
  const { data } = await apiClient.get<ApiResponseWrapper<HrStructureRecord[]>>(path(companyId))
  return Array.isArray(data.data) ? data.data : []
}

export async function createHrStructure(
  companyId: string,
  payload: HrStructurePayload
): Promise<HrStructureRecord> {
  const { data } = await apiClient.post<ApiResponseWrapper<HrStructureRecord>>(path(companyId), payload)
  return data.data
}

export async function updateHrStructure(
  companyId: string,
  id: string,
  payload: Partial<Omit<HrStructurePayload, 'kind' | 'parentId'>> & { parentId?: string | null; active?: boolean }
): Promise<HrStructureRecord> {
  const { data } = await apiClient.patch<ApiResponseWrapper<HrStructureRecord>>(
    `${path(companyId)}/${id}`,
    payload
  )
  return data.data
}
